import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'

import { URL_CHECKOUT } from '@shared/contants'
import Button from '@shared/ui/button'

export default function GoToCheckout () {
  const navigate = useNavigate()
  const { t: tc } = useTranslation('cart')

  const handleClick = async () => {
    navigate(URL_CHECKOUT)
  }

  return (
    <Button
      size="large"
      to={URL_CHECKOUT}
      onClick={handleClick}
      theme="primary"
    >
      {tc('total.checkout')}
    </Button>
  )
}
